module.exports = {
    data() {
        return {
            spaceTypes: [
                {id: 'auditorium', label: 'Auditorium'},
                {id: 'auto_repair', label: 'Auto Repair / Maintenance'},
                {id: 'audience_seating_area', label: 'Audience Seating'},
                {id: 'beauty_salong', label: 'Beauty Salon'},
                {id: 'civic_meeting_place', label: 'Civic Meeting Place'},
                {id: 'concourse_atria', label: 'Concourse and Atria Area'},
                {id: 'classroom', label: 'Classroom, Lecture, Training, Vocational'},
                {id: 'warehouse', label: 'Commercial Industrial Storage'},
                {id: 'convention', label: 'Convention'},
                {id: 'copy_room', label: 'Copy Room'},
                {id: 'corridor_area', label: 'Corridor Area'},
                {id: 'dining_area', label: 'Dining Area'},
                {id: 'electrical_mechanical', label: 'Electrical, Mechanical, Telephone Rooms'},
                {id: 'fitness', label: 'Exercise/Fitness Center and Gymnasium'},
                {id: 'financial', label: 'Financial Transaction Area'},
                {id: 'commercial', label: 'General/Commercial'},
                {id: 'grocery', label: 'Grocery'},
                {id: 'medical', label: 'Healthcare Facility and Hospitals'},
                {id: 'hotel', label: 'Hotel Function Area'},
                {id: 'general_industrial', label: 'Industrial Work Area'},
                {id: 'kitchen_food', label: 'Kitchen/Food Preparation Area'},
                {id: 'laundry', label: 'Laundry Area'},
                {id: 'library', label: 'Library'},
                {id: 'locker_room', label: 'Locker Room'},
                {id: 'lounge', label: 'Lounge, Breakroom, or Waiting Area'},
                {id: 'museum', label: 'Museum'},
                {id: 'main_entry_lobby', label: 'Main Entry Lobby'},
                {id: 'office', label: 'Office'},
                {id: 'outdoot', label: 'Outdoor'},
                {id: 'parking', label: 'Parking Garage Area'},
                {id: 'pharmacy', label: 'Pharmacy Area'},
                {id: 'religious', label: 'Religious Worship Area'},
                {id: 'retail', label: 'Retail Sales Area'},
                {id: 'restaurant', label: 'Restaurant'},
                {id: 'restrooms', label: 'Restrooms'},
                {id: 'laboratory', label: 'Scientific Laboratory Area'},
                {id: 'school', label: 'School'},
                {id: 'sports_arena', label: 'Sports Arena – Playing Area'},
                {id: 'stairwell', label: 'Stairwell'},
                {id: 'theater', label: 'Theater Area'},
                {id: 'transportation', label: 'Transportation Function'},
                {id: 'videoconferencing_studio', label: 'Videoconferencing Studio'},
                // {id: 'other', label: 'Other'},
            ]
        }
    }
}